import { Controller } from "@hotwired/stimulus"
import FieldsCreator from '../shared/issues/call_center_fields'

export default class extends Controller {
  renderIssueFields(event) {
    const targetDataset = event.currentTarget.dataset

    if (!event.currentTarget.checked) {
      document.querySelector(`#container-${targetDataset.fieldIndex}`)?.remove()
    } else {
      const creator = new FieldsCreator(this.#creatorParams(targetDataset))
      this.#addFormFields(targetDataset.target, creator.getIssuableForm())
    }
  }

  #addFormFields(targetId, section) {
    const fieldsContainer = document.getElementById(targetId)
    fieldsContainer.appendChild(section)
  }

  #creatorParams(dataset) {
    return {
      sectionId: dataset.fieldIndex,
      modelName: dataset.fieldModel,
      currentUserId: dataset.currentUserId,
      issuableId: dataset.issuableId,
      issuableType: dataset.issuableType,
      revisionNumber: dataset.revisionNumber,
      issuableAttribute: dataset.issuableAttribute,
      sectionCode: dataset.sectionCode
    }
  }
}
